import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import {
    ICrossConcernsApi,
    IDisclosuresActionsDetailsDto,
    IEnquiriesActionsDetailsDto,
    IRequestsUploadsActionsDetailListDto
} from '@vivli/features/dashboard/infrastructure/interface';

export const useCrossConcernsApi = (): ICrossConcernsApi => {
    const { handleGet, handlePost, handlePut, handleDelete } = useAuthRestApi();
    const getRequestUploadActionDetails = (): Observable<IRequestsUploadsActionsDetailListDto> => {
        return handleGet<IRequestsUploadsActionsDetailListDto>(`/CrossConcern/RequestUploadAwaitingAction`);
    };

    const getDisclosureActionDetails = (): Observable<IDisclosuresActionsDetailsDto> => {
        return handleGet<IDisclosuresActionsDetailsDto>(`/CrossConcern/AwaitingDisclosureAction`);
    };

    const getEnquiryActionDetails = (): Observable<IEnquiriesActionsDetailsDto> => {
        return handleGet<IEnquiriesActionsDetailsDto>(`/CrossConcern/AwaitingEnquiryAction`);
    };

    return {
        getRequestUploadActionDetails,
        getDisclosureActionDetails,
        getEnquiryActionDetails
    };
};
